import store from "@/vue/planning/store/store"
import { getCookie, getParticipantsAmount } from "@/utils/utils"

export default {  
    setSelectedPrestIds: ({state, getters, commit, dispatch}, {scrollToSummary = true, ...obj}) => {
        const prestations = getters.prestations
        const variants = getters.variants
        const selectedPrestationsAmount = getters.selectedPrestations.length
        const selectedPrestIds = state.selectedPrestIds

        Object.entries(obj).forEach(([id, quantity])=>{

            // find prestation and variant
            let prestation = prestations.find(prest=>{
                return !!prest.variants.find((v)=>{
                    return v.id===id
                })
            })

            let variant = variants.find(v=>v.id === id)
            const isFlexVariant = !!variant.pvFlex
            const isNewSkiPassVariant = !!variant.isNewSkiPassValid
            
            // New FR locale ski pass check
            const isFRSkiPassVariant = store.getters.isLocaleFR && 
                variant && 
                (variant.skipass === 7 || variant.skipass === 8) && 
                (variant.codePackage === "PFTTF" || variant.codePackage === "PFPTTF") &&
                variant.prestation && 
                variant.prestation.variants &&
                new Set(variant.prestation.variants
                    .filter(v => v && v.codePackage === variant.codePackage)
                    .map(v => v && v.skipass))
                .size > 1;
                
            const isSpecialVariant = isFlexVariant || isNewSkiPassVariant || isFRSkiPassVariant
            if (!variant) throw new Error("prestation variant not found while adding selection")

            if(isSpecialVariant && !validateSpecialVariatSelection(state, variant)) {
                if(!isNewSkiPassVariant) {
                    commit(
                        "setErrorMessageOpen", 
                        "errorMessages_PVFlex"
                    )
                    return
                } 
                else {
                    commit(
                        "setErrorMessageOpen", 
                        "errorMessages_PF_AND_PFP"
                    )
                }
                return
            }
            
            const currentQuantity = selectedPrestIds[id] || 0
            const difference = quantity - currentQuantity
            const company = getCookie('company')
            
            /**
             * Unselects all other variants in the given prestation, and if it's a special variant,
             * it will also reset the flex type amount or DaysOfSkiPass for those unselected variants.
             * 
             * @param {Object} prestation - The prestation object containing variants.
             * @param {string|number} id - The ID of the selected variant.
             * @param {boolean} isSpecialVariant - Indicates if the variant is special.
             * @param {Object} state - The Vuex state object containing selectedFlexTypes and skiPass6or7Days.
             * @param {Function} commit - The commit function to trigger Vuex mutations.
             */
            prestation.variants.forEach((prestVariant)=>{
                if (prestVariant.id === id) return
                const unselectObject = {}
                unselectObject[prestVariant.id] = 0
                // unselect all other variant flex type
                if(isSpecialVariant) {
                    // Unselect all other variant flex types
                    if(state.selectedFlexTypes[prestVariant.pvFlex] > 0) {
                        commit("setFlexTypeAmount", {flexType: prestVariant.pvFlex, increaseAmount: false})
                    }
                    // Reset ski pass days if selected
                    if(state.skiPassDays[`days${prestVariant.skipass}`] > 0) {
                        const daysAmount = `days${prestVariant.skipass}`
                        commit("setSkiPassDays", {daysAmount, increaseAmount: false})
                    }
                    // For FR locale - Reset 7 or 8 days ski pass if selected
                    if(store.getters.locale === "fr_FR" && 
                       state.skiPass7or8Days && 
                       prestVariant.skipass && 
                       state.skiPass7or8Days[`days${prestVariant.skipass}`] > 0) {
                        const daysAmount = `days${prestVariant.skipass}`
                        commit("set7or8DaysOfSkiPass", {daysAmount, increaseAmount: false})
                    }
                }
                commit("setSelectedPrestIds", unselectObject)
            })

            const remainingAdditionalHebergements = getters.remainingAdditionalHebergements
            
            if (difference > 0) { // if adding - check for validity
                if (store.getters.locale === "fr_FR_CSE" && (company === 'cgos' || company === 'cgosaura') && selectedPrestationsAmount >= 1) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanOneOnCGOS'
                    )
                    return
                }
                if (store.getters.locale === "fr_FR_CSE" && (company === 'cgos' || company === 'cgosaura') && prestation.capacity < getParticipantsAmount()) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_lessPrestationThanAdultsCGOS'
                    )
                    return
                }
                if (remainingAdditionalHebergements === 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (remainingAdditionalHebergements - difference < 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (quantity > variant.quantity) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
            }
    
            // commit if entry is valid
            const object = {}
            object[id] = quantity
            const daysAmount = `days${variant.skipass}`
            
            /**
             * Adjusts the amount of flex type or DaysOfSkiPass based on the quantity and 
             * updates the selected fusion ID accordingly.
             * 
             * @param {boolean} isSpecialVariant - Indicates if the variant is special (Flex || New Ski Pass Pacakge combo (PF/PFP for 6 or 7 days)).
             * @param {boolean} quantity - Indicates if a quantity exists (true to add, false to subtract).
             * @param {Object} variant - The variant object containing the details.
             * @param {number} daysAmount - The amount of days for the ski pass, after edition. (EX: '7' became 'days7')
             * @param {boolean} isNewSkiPassVariant - Indicates if the variant is a New Ski Pass.
             * @param {Function} commit - The commit function to trigger Vuex mutations.
             */
            if(isSpecialVariant && quantity ) {
                handleSpecialVariantIncreaseAmount(variant, daysAmount, isNewSkiPassVariant, commit)
            }else if(isSpecialVariant && !quantity){
                handleSpecialVariantDecreaseAmount(variant, daysAmount, isNewSkiPassVariant, commit)
            }

            commit("setSelectedPrestIds", object)
            
            // close dropdown
            commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
        })

        if (!state.scrollToPrestationFired && scrollToSummary) {
            setTimeout(()=>{
                window.dispatchEvent(new CustomEvent("smoothScrollToSelector", {detail: {selector: "#summary", block: "center"}}))
            }, 200)
            commit("setScrollToPrestationFired", true)
        }

        dispatch("refreshDataStoredOnWindow")
    },
}

/**
 * Handles the increase of flex type amount or DaysOfSkiPass based on the variant type,
 * and adds the selected fusion ID.
 * 
 * @param {Object} variant - The variant object containing the details.
 * @param {number} daysAmount - The amount of days for the ski pass.
 * @param {boolean} isNewSkiPassVariant - Indicates if the variant is a new ski pass.
 * @param {Function} commit - The commit function to trigger Vuex mutations.
 */
function handleSpecialVariantIncreaseAmount(variant, daysAmount, isNewSkiPassVariant, commit) {
    // Check if it's a FR skipass variant
    const isFRSkiPass = store.getters.isLocaleFR && 
        variant && variant.skipass && 
        (variant.skipass === 7 || variant.skipass === 8) && 
        variant.codePackage && 
        (variant.codePackage === "PFTTF" || variant.codePackage === "PFPTTF");
        
    if(!isNewSkiPassVariant && !isFRSkiPass) {
        // PV Flex case
        if (variant.pvFlex) {
            commit("setFlexTypeAmount", {flexType: variant.pvFlex})
        }
        if (variant.prestIdFusion) {
            commit("addSelectedPrestIdFusion", variant.prestIdFusion)
        }
    } else {
        // Both NL and FR skipass cases
        if (daysAmount) {
            commit("setSkiPassDays", {daysAmount})
        }
        if (isFRSkiPass && daysAmount) {
            // FR specific handling
            commit("set7or8DaysOfSkiPass", {daysAmount})
        }
        if (variant.prestIdFusion) {
            commit("addSelectedPrestIdFusion", variant.prestIdFusion)
        }
    }
}

/**
 * Handles the decrease of flex type amount or DaysOfSkiPass based on the variant type,
 * and removes the selected fusion ID.
 * 
 * @param {Object} variant - The variant object containing the details.
 * @param {number} daysAmount - The amount of days for the ski pass.
 * @param {boolean} isNewSkiPassVariant - Indicates if the variant is a new ski pass.
 * @param {Function} commit - The commit function to trigger Vuex mutations.
 */
function handleSpecialVariantDecreaseAmount(variant, daysAmount, isNewSkiPassVariant, commit) {
    const increaseAmount = false
    
    // Check if it's a FR skipass variant
    const isFRSkiPass = store.getters.isLocaleFR && 
        variant && variant.skipass && 
        (variant.skipass === 7 || variant.skipass === 8) && 
        variant.codePackage && 
        (variant.codePackage === "PFTTF" || variant.codePackage === "PFPTTF");
        
    if(!isNewSkiPassVariant && !isFRSkiPass) {
        // PV Flex case
        if (variant.pvFlex) {
            commit("setFlexTypeAmount", {flexType: variant.pvFlex, increaseAmount})
        }
        if (variant.prestIdFusion) {
            commit("removeSelectedPrestIdFusion", variant.prestIdFusion)
        }
    } else {
        // Both NL and FR skipass cases
        if (daysAmount) {
            commit("setSkiPassDays", {daysAmount, increaseAmount})
        }
        if (isFRSkiPass && daysAmount) {
            // FR specific handling
            commit("set7or8DaysOfSkiPass", {daysAmount, increaseAmount})
        }
        if (variant.prestIdFusion) {
            commit("removeSelectedPrestIdFusion", variant.prestIdFusion)
        }
    }
}

/**
 * Validates the selection of a special variant based on the current state.
 * It checks if the selected variant conforms to the rules regarding 
 * flex type and ski pass days selection.
 * 
 * @param {Object} state - The Vuex state object containing selectedPrestIdsFusion, selectedFlexTypes, and skiPass6or7Days.
 * @param {Object} variant - The variant object containing prestIdFusion, pvFlex, and skipass details.
 * @returns {boolean} - Returns true if the variant selection is valid based on the current state, otherwise false.
 */
function validateSpecialVariatSelection(state, variant) {
    if (!variant || !state) return true; // If variant or state is undefined, allow selection
    
    const isPrestationSelected = variant.prestIdFusion && state.selectedPrestIdsFusion && 
        state.selectedPrestIdsFusion.has(variant.prestIdFusion);
    
    const isFlexTypeSelected = variant.pvFlex && state.selectedFlexTypes &&
        state.selectedFlexTypes[variant.pvFlex];
    
    const isSkiPassDaysSelected = variant.skipass && state.skiPassDays &&
        state.skiPassDays[`days${variant.skipass}`];
    
    // Check for FR skipass (7 or 8 days)
    const isFRSkiPass = store.getters.isLocaleFR && 
        variant.skipass && 
        (variant.skipass === 7 || variant.skipass === 8) && 
        variant.codePackage &&
        (variant.codePackage === "PFTTF" || variant.codePackage === "PFPTTF");
    
    const isFR7or8SkiPassDaysSelected = isFRSkiPass && 
        state.skiPass7or8Days && 
        variant.skipass &&
        state.skiPass7or8Days[`days${variant.skipass}`];
    
    // Return true if the flex type is selected or no prestation is selected yet
    if (isFlexTypeSelected || !state.selectedPrestIdsFusion || !state.selectedPrestIdsFusion.size) {
        return true;
    }

    // Return true if the ski pass days are selected (either NL or FR) or no prestation is selected yet
    if ((isSkiPassDaysSelected || isFR7or8SkiPassDaysSelected) || 
        !state.selectedPrestIdsFusion || !state.selectedPrestIdsFusion.size) {
        return true;
    }

    // When flex type is not selected
    // Return true if exactly one prestation is selected and it matches the current variant
    // Otherwise, return false
    return isPrestationSelected && state.selectedPrestIdsFusion && state.selectedPrestIdsFusion.size === 1;
}